export const EXCMREGIONUSERDATA_SHOW_RESET = 'EXCMREGIONUSERDATA_SHOW_RESET'
export const EXCMREGIONUSERDATA_SHOW_SET_ERROR = 'EXCMREGIONUSERDATA_SHOW_SET_ERROR'
export const EXCMREGIONUSERDATA_SHOW_SET_RETRIEVED = 'EXCMREGIONUSERDATA_SHOW_SET_RETRIEVED'
export const EXCMREGIONUSERDATA_SHOW_TOGGLE_LOADING = 'EXCMREGIONUSERDATA_SHOW_TOGGLE_LOADING'
